export var Cache;Cache||(Cache={});